const { exec, spawn, execFile } = window.require("child_process");

import fileSys from "../../../fileoprators/fileSystem";
import { isArray } from "../../../shared/utils";
import nmcli from "../wifi/NmcliHelper";

function runCmd(cmd) {
  return new Promise((resolve) => {
    exec(`echo ' ' | sudo -S ${cmd}`, (error, stdout) => {
      if (error) {
        console.error(error);
        resolve(undefined);
      } else {
        resolve(stdout.toString());
      }
    });
  });
}
function maskToCidr(mask) {
  const binaryMask = mask
    .split(".")
    .map((octet) => {
      let binaryOctet = parseInt(octet).toString(2);
      // 如果不是8位二进制数，需要补零
      if (binaryOctet.length < 8) {
        binaryOctet = "0".repeat(8 - binaryOctet.length) + binaryOctet;
      }
      return binaryOctet;
    })
    .join("");

  // 计算连续1的数量
  let onesCount = 0;
  for (let i = 0; i < binaryMask.length; i++) {
    if (binaryMask[i] === "1") {
      onesCount++;
    } else if (onesCount !== 0) {
      break; // 遇到第一个0，停止计数
    }
  }

  return onesCount;
}
async function getEthGateway(ethport) {
  let str = await runCmd(`route -n | grep ${ethport} | grep UG`);
  if (str) {
    return str.toString().split(" ")[9].trim();
  }
  return str;
}

async function getDns(ethport) {
  let str = await runCmd(`nmcli dev show ${ethport} | grep DNS`);
  if (str && str.toLowerCase().indexOf("error") < 0) {
    str = str.split(/\s+/)[1].trim();
    return str;
  }
  return "";
}
async function getUuid(ethport) {
  let str = await runCmd(`nmcli con show | grep "UUID\\|${ethport}"`);
  if (str && str.toLowerCase().indexOf("error") < 0) {
    let arr = nmcli.str2wifiArr(str);
    if (Array.isArray(arr) && arr.length > 0 && arr[0].uuid) {
      return arr[0].uuid;
    }
    return "";
  }
  return "";
}
async function getMethod(uuid) {
  let str = await runCmd(`nmcli con show ${uuid}| grep method `);
  if (str && str.toLowerCase().indexOf("error") < 0) {
    str = str.split(/\s+/)[1].trim();
    return str;
  }
  return "";
}
async function getConnectedLan() {
  let lans = fileSys.getLanConfig();
  if (lans && isArray(lans) && lans.length > 0) {
    let obj = JSON.parse(JSON.stringify(lans[0]));
    obj.gateway = await getEthGateway(obj.port);
    obj.dns = await getDns(obj.port);
    obj.uuid = await getUuid(obj.port);
    obj.method = await getMethod(obj.uuid);
    if (!obj.mask && obj.netmask) {
      obj.mask = obj.netmask;
      return [obj];
    }
  }

  return [];
}
async function disconnectLan(lanInfo) {
  let str = await runCmd(`nmcli con down ${lanInfo.uuid}`);

  if (str && str.toLowerCase().indexOf("error") >= 0) {
    return false;
  }
  return true;
}

async function setLanManual(lanInfo) {
  let arrCmd = [
    `nmcli con mod ${lanInfo.uuid} ipv4.addresses "${lanInfo.address}/${maskToCidr(lanInfo.mask)}"`,
    `nmcli con mod ${lanInfo.uuid} ipv4.gateway "${lanInfo.gateway}"`,
    `nmcli con mod ${lanInfo.uuid} ipv4.dns "${lanInfo.dns}"`,
    `nmcli con mod ${lanInfo.uuid} ipv4.method manual`,
    `nmcli con down ${lanInfo.uuid}`,
    `nmcli con up ${lanInfo.uuid}`
  ];
  let str = arrCmd.join(" && ");

  str = await runCmd(str);

  if (str && str.toLowerCase().indexOf("error") >= 0) {
    return false;
  }
  return true;
}
async function setLanAuto(lanInfo) {
  let arrCmd = [
    `nmcli con mod ${lanInfo.uuid} ipv4.method auto`,
    `nmcli con down ${lanInfo.uuid}`,
    `nmcli con up ${lanInfo.uuid}`
  ];
  let str = arrCmd.join(" && ");

  str = await runCmd(str);

  if (str && str.toLowerCase().indexOf("error") >= 0) {
    return false;
  }
  return true;
}
async function openTui() {
  // runCmd(`gnome-terminal --maximize -- "nmtui"`)
  runCmd(`gnome-terminal --hide-menubar --geometry 80x24+350+1 --zoom 2 -- "nmtui"`);
}
export default {
  getConnectedLan,
  disconnectLan,
  setLanManual,
  setLanAuto,
  getUuid,
  openTui
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/ethernet/index.js